import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { contractConstants } from '..';

export const useContractExterminate = (props?: { onSuccess: () => void }) => {
  const qc = useQueryClient();

  return useMutation(
    async (id: number) => {
      const res = await $api.delete(`/v1/contract/delete/${id}`);

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await Promise.allSettled([
          qc.invalidateQueries([contractConstants.queryKeys.CONTRACT]),
          qc.invalidateQueries([contractConstants.queryKeys.STATISTICS])
        ]);

        if (props?.onSuccess) props?.onSuccess();
      }
    }
  );
};
